import React, { useEffect, useState } from "react";

import Box from "./Box";
import CloseButton from "./CloseButton";
import FormError from "./FormError";
import HeadingMain from "./HeadingMain";
import LozengeButton from "./LozengeButton";
import RoundedInput from "./RoundedInput";
import { useAppContext } from "./AppContext";
import { ITEM_BASED } from "../core-modules/constants";
import { useBrand } from "./BrandContext";
import TakebackForm from "./TakebackForm";
import { useTakebackConfig } from "./TakebackConfigContext";

function ApprovalBox() {
  const {
    showInstoreApprovalBox,
    setShowInstoreApprovalBox,
    handleApproveInstoreTakeback,
    takebackItems,
  } = useAppContext();
  const { storePins, incentiveType } = useBrand();
  const { showMinimalBasketUi } = useTakebackConfig();
  const [storePin, setStorePin] = useState("");
  const [numberOfItems, setNumberOfItems] = useState("");
  const [error, setError] = useState(false);

  const handleApprove = () => {
    if (storePins.includes(storePin) && numberOfItems) {
      handleApproveInstoreTakeback(storePin, numberOfItems);
    } else {
      setError(true);
    }
  };

  const showItems = incentiveType === ITEM_BASED || showMinimalBasketUi;

  useEffect(() => {
    if (!showInstoreApprovalBox) setStorePin("");
  }, [showInstoreApprovalBox]);

  useEffect(() => {
    if (showItems) {
      setNumberOfItems(takebackItems.length.toString());
    }
  }, [takebackItems]);

  return (
    <Box
      position="fixed"
      bg="rgba(0,0,0,0.7)"
      top={0}
      left={0}
      height="100vh"
      width="100vw"
      zIndex={1000}
      transition="opacity 200ms"
      opacity={showInstoreApprovalBox ? "1" : "0"}
      pointerEvents={showInstoreApprovalBox ? "all" : "none"}
    >
      <Box position="fixed" top="6vw" right="6vw" zIndex={100}>
        <CloseButton
          onClick={() => {
            setShowInstoreApprovalBox(false);
          }}
        />
      </Box>
      <Box
        overflow="scroll"
        bg="white"
        position="fixed"
        right="5vw"
        left="5vw"
        top="5vw"
        bottom="5vw"
      >
        <Box position="relative" px="8vw" py={150}>
          <HeadingMain pb={[40, 40, 80, 80]}>
            Confirm customer trade-in complies with Takeback rules
          </HeadingMain>
          {showItems && <TakebackForm instore />}
          <Box display="flex" flexDirection={["column", null, "row", null]}>
            <Box
              position="relative"
              width={["100%", null, "50%", null]}
              mr={[null, null, "10px", null]}
              mb={[40, null, 0, null]}
            >
              <RoundedInput
                type="text"
                name="approvalCode"
                onChange={(e) => {
                  if (error) setError(false);
                  setStorePin(e.target.value);
                }}
                placeholder="Store approval code"
                error={(error && numberOfItems) || (error && !storePin)}
                value={storePin}
                autoComplete="off"
              />
              {error && numberOfItems && storePin && (
                <FormError name="approvalCode" positionProps={{ bottom: -20 }}>
                  Approval code not accepted
                </FormError>
              )}
              {error && !storePin && (
                <FormError name="approvalCode" positionProps={{ bottom: -20 }}>
                  Please enter the approval code
                </FormError>
              )}
            </Box>
            {!showItems && (
              <Box
                position="relative"
                width={["100%", null, "50%", null]}
                ml={[null, null, "10px", null]}
              >
                <RoundedInput
                  type="number"
                  name="numberOfItems"
                  onChange={(e) => {
                    if (error) setError(false);
                    setNumberOfItems(e.target.value);
                  }}
                  placeholder="Number of items"
                  error={error && !numberOfItems}
                  value={numberOfItems}
                  autoComplete="off"
                />
                {error && !numberOfItems && (
                  <FormError
                    name="numberOfItems"
                    positionProps={{ bottom: -20 }}
                  >
                    {numberOfItems
                      ? "Approval code not accepted"
                      : "Please enter the number of items"}
                  </FormError>
                )}
              </Box>
            )}
          </Box>

          <Box mt={40}>
            <LozengeButton onClick={handleApprove}>Approve</LozengeButton>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default ApprovalBox;
